import { color } from "@smartsheet/design-tokens-react";
import { ThemeMode } from "@smartsheet/sds-theme-internal";
import { ChipColorVariant } from "../types";

export enum SEMANTIC_CHIP_COLORS {
    "not-started" = "neutral",
    "in-progress" = "blue",
    "completed" = "green",
    "at-risk" = "yellow",
    "blocked" = "red",
}

export const chipCustomCssProperties = {
    text: `--smar--core--chip--text`,
    backgroundRest: `--smar--core--chip--background--rest`,
    backgroundHover: `--smar--core--chip--background--hover`,
    backgroundActive: `--smar--core--chip--background--active`,
    removeButtonOpacity: `--smar--core--chip--remove--button--opacity`,
};

type ColorToken = Parameters<typeof color>[0];
interface GetTokenForColorResult {
    backgroundActive: ColorToken;
    backgroundHover: ColorToken;
    backgroundRest: ColorToken;
    text: ColorToken;
}

export const getTokenForColor = (color: ChipColorVariant, themeMode: ThemeMode): GetTokenForColorResult => {
    switch (themeMode) {
        case "lodestar-light":
            return getTokenForColorLodestar(color);
        default:
            return getTokenForColorDefault(color);
    }
};

const getTokenForColorDefault = (color: ChipColorVariant): GetTokenForColorResult => {
    return {
        text: `color--text--spectrum-${color}--default` as const,
        backgroundRest: `color--background--spectrum-${color}--weakest` as const,
        backgroundHover: `color--background--spectrum-${color}--weaker` as const,
        backgroundActive: `color--background--spectrum-${color}--weak` as const,
    };
};

/**
 * Kinda lame that we need to do this, but Lodestar's Tag and Token components have a much darker
 * theme we want to support since we're upgrading people directly from the Tag/Token to Chip.
 */
const getTokenForColorLodestar = (color: ChipColorVariant): GetTokenForColorResult => {
    return {
        text: `color--text--spectrum-${color}--strong` as const,
        backgroundRest: `color--background--spectrum-${color}--weak` as const,
        backgroundHover: `color--background--spectrum-${color}--default` as const,
        backgroundActive: `color--background--spectrum-${color}--strong` as const,
    };
};
